const firebaseConfig = {
    apiKey: "AIzaSyD7JfoC-Jfh6Cow2OVT3DY8WjmRQ-PaKhI",
    authDomain: "travel-guru2020.firebaseapp.com",
    databaseURL: "https://travel-guru2020.firebaseio.com",
    projectId: "travel-guru2020",
    storageBucket: "travel-guru2020.appspot.com",
    messagingSenderId: "165456316021",
    appId: "1:165456316021:web:b867531accdf0c37735a3c"
  };

  export default firebaseConfig;